import { Link } from 'react-router-dom';
import { useLang } from '../i18n/LanguageContext';

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="relative bg-[#10282C] text-white grain overflow-hidden">
      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <img src="/brand/gyeno-lockup-horizontal-on-dark.svg" alt="Gyeno" className="h-8 w-auto" />
            <p className="mt-5 font-display text-xl font-semibold text-[#00C5C2]">{t('footer.tagline')}</p>
            <p className="mt-3 text-sm text-white/50 max-w-sm leading-relaxed">{t('footer.builtBy')}</p>
            <p className="mt-6 text-xs font-mono tracking-wide text-white/35">{t('footer.regions')}</p>
            <div className="mt-3 flex gap-2">
              {['US', 'UK', 'MEA', 'APAC'].map((r) => (
                <span key={r} className="px-2.5 py-1 rounded-full border border-[#00C5C2]/25 text-[10px] font-mono text-[#00C5C2]/80">{r}</span>
              ))}
            </div>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs font-mono tracking-[0.16em] text-white/40 uppercase">{t('footer.product')}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-product" to="/product" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('nav.product')}</Link></li>
              <li><Link data-testid="footer-link-how" to="/how-it-works" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('nav.howItWorks')}</Link></li>
              <li><Link data-testid="footer-link-integrations" to="/integrations" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('nav.integrations')}</Link></li>
              <li><Link data-testid="footer-link-pricing" to="/pricing" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('nav.pricing')}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="text-xs font-mono tracking-[0.16em] text-white/40 uppercase">{t('footer.company')}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-enterprise" to="/enterprise" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('nav.enterprise')}</Link></li>
              <li><Link data-testid="footer-link-faq" to="/faq" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('nav.faq')}</Link></li>
              <li><Link data-testid="footer-link-signup" to="/signup" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('footer.signup')}</Link></li>
              <li><Link data-testid="footer-link-contact" to="/enterprise" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('footer.contact')}</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs font-mono tracking-[0.16em] text-white/40 uppercase">{t('footer.legal')}</p>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li><Link data-testid="footer-link-privacy" to="/privacy" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('footer.privacy')}</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="text-white/70 hover:text-[#00C5C2]" style={{ transition: 'color 0.2s ease' }}>{t('footer.terms')}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-16 pt-7 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-white/35">{t('footer.rights')}</p>
          <p className="text-xs font-mono text-white/25">gyeno · {t('trust.builtFor')}</p>
        </div>
      </div>
    </footer>
  );
}
